export const regexName =
  /^(?!\s)(?!.*\s$)(?!^\s)[A-Za-zñÑáéíóúÁÉÍÓÚ]+(['|\-|\s]?[A-Za-zñÑáéíóúÁÉÍÓÚ]+)*$/;
export const regexTitle =
  /^(?!\s)(?!.*\s$)(?!^\s)(['"]?[A-Za-zñÑáéíóúÁÉÍÓÚ0-9]+(['|\-_\s]?[A-Za-zñÑáéíóúÁÉÍÓÚ0-9"'|]+)*['"]?)$/;
export const regexEmail = /^[a-z0-9][-a-z0-9._]+@([-a-z0-9]+[.])+[a-z]{2,5}$/;
export const regexPhoneWithCode = /^(\+?)[0-9]{5,30}$/;
export const regexPhone = /^[0-9]{10}$/;
export const regexNumber = /^[0-9]+$/;
export const regexNumberID = /^(\+?)[0-9]{3,20}$/;
export const regexPassword = /^[\w]{6,30}$/;
export const regexOTP = /^[0-9]{4}$/;
export const regexNumInPath = /\d+/;
export const regexKeyName = /^([a-zA-Z0-9](_?|-?))+([a-zA-Z0-9])$/;
export const regexObjectKey = /^[a-zA-Z]+(?:[-_][a-zA-Z]+)*$/;
export const regexURL =
  /^(http(s?):\/\/)?(((www\.)?[a-zA-Z0-9.\-_]+(\.[a-zA-Z]{2,3})+)|(\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b))(:(\d{1,5}))?(\/[a-zA-Z0-9_\-\s./?%#&=]*)?$/i;
export const regexSerial = /^[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*$/;
export const regextSerialMax39 = /^(?=.{39}$)[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*$/;
export const regexCURP =
  /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
export const regexRFC =
  /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
export const regexNSS = /^(\d{2})(\d{2})(\d{2})\d{5}$/;
export const regexAlphaNumeric = /^[a-zA-Z0-9]+$/;
export const regexIPv4 =
  /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

export function validateIPv4(ip) {
  return regexIPv4.test(ip);
}

export function validateName(name) {
  return regexName.test(name);
}

export function validateTitle(name) {
  return regexTitle.test(name);
}

export function validateEmail(email) {
  return regexEmail.test(email);
}

export function validatePhone(phone) {
  return regexPhone.test(phone);
}

export function validateNumber(number) {
  return regexNumber.test(number);
}

export function validateNumberID(id) {
  return regexNumberID.test(id);
}

export function validatePassword(password) {
  return regexPassword.test(password);
}

export function validatePin(pin) {
  return regexOTP.test(pin);
}

export function validateNumberInPath(path) {
  return regexNumInPath.test(path);
}

export function validateKeyName(keyName) {
  return regexKeyName.test(keyName);
}

export function validateObjectKey(keyName) {
  return regexObjectKey.test(keyName);
}

export function validateURL(URL) {
  return regexURL.test(URL);
}

export function validateSerial(serial) {
  return regexSerial.test(serial);
}

export function validateSerialMax39(serial) {
  return regextSerialMax39.test(serial);
}

export function validateCURP(curp) {
  return regexCURP.test(curp);
}

export function validateRFC(rfc) {
  return regexRFC.test(rfc);
}

export function validateNSS(nss) {
  return regexNSS.test(nss);
}
